export const LOGIN_USER = "@INQUERITO/LOGIN_USER";

export const SELECT_PROFILE = "@INQUERITO/SELECT_PROFILE";

export const UPDATE_USER = "@INQUERITO/UPDATE_USER";
export const CHANGE_USER_PREFERENCES = "@KENTA/CHANGE_USER_PREFERENCES";

export const SET_TIME_TO_COUNT = "@KENTA/SET_TIME_TO_COUNT";
